import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { IEventNote, IPendingEventNote } from '../../../../../../data/entities/event/event-note';
import { FormInputTextArea, FormLabel } from '../../../../../components/form';
import { Paragraph } from '../../../../../components/paragraph/Paragraph';

interface ITransferBookingModalProps {
	propertyId: number | string;
	eventId: string;
	onRequestClose: () => any;
	transferBooking: () => any;
	submitEventNotes: (propertyId: string | number, eventId: string, eventNotes: IPendingEventNote[]) => any;
}

export const TransferBookingModal: React.FC<ITransferBookingModalProps> = (props) => {
	const { propertyId, eventId, submitEventNotes, transferBooking, onRequestClose } = props;
	const [comment, setComment] = React.useState('');

	const onSave = async () => {
		const pend = {
			action: 'add',
			eventNote: {
				event_id: eventId,
				note_type: 'audit',
				content: `Booking transfer initiated${comment ? '\nComment - ' + comment : ''}`
			} as IEventNote,
			eventId
		} as IPendingEventNote;
		await submitEventNotes(propertyId, eventId, [pend]);
		await transferBooking();
		onRequestClose();
	};

	return <Modal
		title="Booking transfer request"
		shouldCloseOnOverlayClick={false}
		onRequestClose={onRequestClose}
		actionRHS={
			<Button
				id="booking_transfer_reason_save"
				onClick={onSave}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
			>
				Save
			</Button>}
	>
		<div className="booking_transfer_content">
			<Paragraph>Please add a comment to explain why the booking is being transferred</Paragraph>
			<Paragraph>This will be used for internal auditing</Paragraph>
			<FormLabel htmlFor="booking_transfer--comment">Comment</FormLabel>
			<FormInputTextArea id="booking_transfer--comment" defaultValue={comment} onChange={(e) => setComment(e.target.value)} />
		</div>
	</Modal>;
};
